<div class="automation-rules">

  <sc-master-detail [selection]="[selectedProfile]" [data]="profiles" (selectionChanged)="onSelectionChanged($event);"
    (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);" [newStyle]="true">
    <sc-scroll-pane>
      @if (selectedProfile != null) {
        <form [formGroup]="detailsForm">
          <div class="automation-rule-details no-field-space">
            <sc-tab-group>
              <sc-tab titleDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.base-data">
                <sc-content-spacer vertical></sc-content-spacer>
                <sc-checkbox-field formControlName="active" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.active">
                </sc-checkbox-field>
                <sc-flex>
                  <sc-checkbox-field formControlName="hasQrCode" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.has-qr-code">
                  </sc-checkbox-field>
                  <sc-content-spacer grow></sc-content-spacer>
                  <sc-button dictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.create-pdf" [disabled]="!selectedProfile.hasQrCode" (click)="createPDF()"></sc-button>
                </sc-flex>
                <sc-content-spacer vertical></sc-content-spacer>
                <sc-string-field formControlName="name" labelDictionaryKey="tmc-yard.common.name">
                </sc-string-field>
                <sc-content-spacer vertical></sc-content-spacer>
                <sc-checkbox-field formControlName="hasActionTablet" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.has-action-tablet">
                </sc-checkbox-field>
                @if (displayNameVisible) {
                  <sc-content-spacer vertical></sc-content-spacer>
                  <sc-string-field formControlName="displayName" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.display-name">
                  </sc-string-field>
                }
                <sc-content-spacer vertical></sc-content-spacer>
              </sc-tab>
              <sc-tab titleDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.properties">
                <sc-content-spacer vertical></sc-content-spacer>
                <sc-checkbox-field formControlName="allowParallelAccess" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.allow-parallel-access">
                </sc-checkbox-field>
                <sc-content-spacer vertical></sc-content-spacer>
                <sc-checkbox-field formControlName="withRouting" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.with-routing">
                </sc-checkbox-field>
                <sc-content-spacer vertical></sc-content-spacer>
                @if (!numberPlateEnabled) {
                  <sc-read-only-field
                    labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.hash-code"
                    [value]="selectedProfile?.hashCode">
                  </sc-read-only-field>
                }
                @if (!numberPlateEnabled) {
                  <sc-content-spacer vertical></sc-content-spacer>
                }
                <sc-string-field formControlName="carrier" labelDictionaryKey="tmc-yard.entity.transport.carrier">
                </sc-string-field>
                <sc-content-spacer vertical></sc-content-spacer>
                <sc-string-field formControlName="driver" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.driver">
                </sc-string-field>
                @if (!numberPlateEnabled) {
                  <sc-content-spacer vertical></sc-content-spacer>
                }
                @if (!numberPlateEnabled) {
                  <sc-string-field formControlName="numberPlate" labelDictionaryKey="tmc-yard.entity.transport.numberplate">
                  </sc-string-field>
                }
                <sc-content-spacer vertical></sc-content-spacer>
                <sc-string-field formControlName="orderReference" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.order-reference">
                </sc-string-field>
                <sc-content-spacer vertical></sc-content-spacer>
                <sc-padding>
                  <app-transport-options-panel [model]="transportOptionsPanelModel"></app-transport-options-panel>
                </sc-padding>
              </sc-tab>
              <sc-tab titleDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.number-plates">
                <sc-content-spacer vertical></sc-content-spacer>
                <sc-checkbox-field formControlName="hasNumberPlateList" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.has-number-plate-list">
                </sc-checkbox-field>
                @if (numberPlateEnabled) {
                  <app-number-plate [selectedProfile]="selectedProfile"
                    (deleteClicked)="deleteNumberPlate($event)" (changeActiveClicked)="changeNumberPlateActive($event)"
                  (addNewNumberPlateClicked)="addNewNumberPlate($event)"></app-number-plate>
                }
              </sc-tab>
            </sc-tab-group>
          </div>
        </form>
      }
    </sc-scroll-pane>

    <ng-template masterDetailToolbar>

      <sc-cancel-button class="config-changed-button" (click)="cancel()" [disabled]="!cancelEnabled"></sc-cancel-button>
      <div class="spacer"></div>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary class="config-changed-button" (click)="save()" [disabled]="!saveEnabled"></sc-save-button>

    </ng-template>
  </sc-master-detail>

</div>
